import { render, staticRenderFns } from "./Receipt.vue?vue&type=template&id=a543a0fc&scoped=true&"
import script from "./Receipt.vue?vue&type=script&lang=ts&"
export * from "./Receipt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a543a0fc",
  null
  
)

export default component.exports